import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import styled from 'styled-components'

export const Card = styled.section`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  padding: ${spacing(4)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: ${base_colorRaisedSurface};
  color: ${text_colorTextPrimary};
`

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
`

export const Title = styled.h2`
  ${font_md};
  margin: 0;
  font-family: ${font_family_weight_medium};
`

export const Context = styled.p`
  ${font_sm};
  margin: 0;
  color: ${text_colorTextSecondary};
`

export const Chart = styled.div`
  width: 100%;
  height: 260px;
  min-height: 220px;

  > div,
  svg {
    width: 100%;
    height: 100%;
  }
`
